import {React,useState} from 'react'
import { Container,Row,Col } from 'react-bootstrap'
import CommonSection from '../components/UI/CommonSection'
import Helmet from '../components/Helmet/Helmet'
import products from '../assets/data/products'
import ProductList from '../components/UI/ProductList'

import '../assets/style/shop.css'
import { useSearchParams } from 'react-router-dom'


const Shop = () => {

  const [productsData,setProductsData] = useState(products)

  // اختيار نوع المنتج
  const handleFilter = (e)=>{
    const filterValue = e.target.value
    if(filterValue === 'sofa'){
      const filteredProducts = products.filter(item=>item.category==='sofa')
      setProductsData(filteredProducts)
    }
    else if(filterValue === 'mobile'){
      const filteredProducts = products.filter(item=>item.category==='mobile')
      setProductsData(filteredProducts)
    }
    else if(filterValue === 'chair'){
      const filteredProducts = products.filter(item=>item.category==='chair')
      setProductsData(filteredProducts)
    }
    else if(filterValue === 'watch'){
      const filteredProducts = products.filter(item=>item.category==='watch')
      setProductsData(filteredProducts)
    }
    else if(filterValue === 'wireless'){
      const filteredProducts = products.filter(item=>item.category==='wireless')
      setProductsData(filteredProducts)
    }
  }

  // const handleSearch = (e)=>{
  //   const searchInput = e.target.value 
  //   const searchProducts = products.filter(item=>item.productName.toLowerCase().includes(searchInput.toLowerCase()))
  //   setProductsData(searchProducts)
  // }

    const [searchParams, setSearchParams] = useSearchParams();
    const [searchQuery, setSearchQuery] = useState(searchParams.get("q") || "");

    const handleSearch = (event) => {
      event.preventDefault();
      const searchProducts = products.filter(item=>item.productName.toLowerCase().includes(searchQuery.toLowerCase()))
      setSearchParams({ q: searchQuery });
      setProductsData(searchProducts)
      setSearchQuery('')
    };

  return (
    <div>
      <Helmet title='Shop'/>
      <CommonSection title='Products'/>

      <section>
        <Container>
          <Row>
            
            <Col lg='3' md='6'>
              <div className='filter__widget'>
                <select onChange={handleFilter}>
                  <option>Filter By Category</option>
                  <option value="sofa">Sofa</option>
                  <option value="mobile">Mobile</option>
                  <option value="chair">Chair</option>
                  <option value="watch">Watch</option>
                  <option value="wireless">Wireless</option>
                </select>
              </div>
            </Col>

            <Col lg='3' md='6' >
              <div className='filter__widget text-end'>
                <select>
                  <option>Sort By</option>
                  <option value="ascending">Ascending</option>
                  <option value="descending">Descending</option>
                </select>
              </div>
            </Col>

            <Col lg='6' md='12'>
              <form onSubmit={handleSearch}>
                <div className="search__box">
                  <input onChange={(event) => setSearchQuery(event.target.value)} value={searchQuery} type="text" placeholder='Search...' />
                  <button onSubmit={handleSearch} type='submit'><i className='ri-search-line'></i></button>
                </div>
              </form>
            </Col>
          </Row>
        </Container>
      </section>

      <section className=''>
        <Container>
        <Row>
            {productsData.length === 0 ?
            <h1 className='text-center fs-5'>
              No Products are Found!
            </h1>: <ProductList data={productsData}/>}
          </Row>
        </Container>
      </section>
    </div>
  )
}

export default Shop